import { render, staticRenderFns } from "./switchStatus.vue?vue&type=template&id=251b3834&scoped=true"
import script from "./switchStatus.vue?vue&type=script&lang=js"
export * from "./switchStatus.vue?vue&type=script&lang=js"
import style0 from "./switchStatus.vue?vue&type=style&index=0&id=251b3834&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251b3834",
  null
  
)

export default component.exports